/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientDetailOptionsViewModel } from '../../models/client-detail-options-view-model';

export interface GetClientDetailOptions$Params {
  clientID: number;
}

export function GetClientDetailOptions(http: HttpClient, rootUrl: string, params: GetClientDetailOptions$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientDetailOptionsViewModel>> {
  const rb = new RequestBuilder(rootUrl, GetClientDetailOptions.PATH, 'get');
  if (params) {
    rb.path('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientDetailOptionsViewModel>;
    })
  );
}

GetClientDetailOptions.PATH = '/api/Clients/GetClientDetailOptions/{clientID}';
